import React, { useState, useEffect } from 'react';
import {

    CircularProgress,


    Box,
    Container,
    Grid,
    Paper,
    Stack,
    Chip
} from '@mui/material';
import { Card, Spin, Alert, Typography, Button, Space } from 'antd';

import {
    ArrowBack,
    Download,
    Print,
    Security,
    ContactSupport,
    Assignment,
    PrivacyTip,
    Cookie,
    Share
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import './terms.css';
const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
    const [content, setContent] = useState({
        title: '',
        content: '',
        lastUpdated: ''
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchContent();
    }, []);

    const fetchContent = async () => {
        try {
            setLoading(true);
            // const response = await fetch('/api/termsconditions');

            const response = await fetch('/api/termsconditions', {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                },
            });

            if (!response.ok) throw new Error('Failed to fetch content');
            const data = await response.json();
            setContent({
                title: data.privacy?.title || 'Privacy Policy',
                content: data.privacy?.content || '',
                lastUpdated: data.privacy?.lastUpdated || ''
            });
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = () => {
        window.print();
    };

    const handleDownload = () => {
        const blob = new Blob([`
      ${content.title}
      
      ${content.content.replace(/<[^>]*>/g, '')}
      
      Last updated: ${content.lastUpdated ?
                new Date(content.lastUpdated).toLocaleDateString() :
                new Date().toLocaleDateString()}
    `], { type: 'text/plain' });

        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `privacy_policy.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
    };

    if (loading) {
        return (
            <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                <Header />
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '50vh',
                        gap: 2
                    }}
                >
                    <CircularProgress size={60} />
                    <Typography variant="h6" color="text.secondary">
                        Loading Privacy Policy...
                    </Typography>
                </Box>
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
                <Header />
                <Container sx={{ py: 4 }}>
                    <Alert
                        severity="error"
                        action={
                            <Button color="inherit" size="small" onClick={fetchContent}>
                                RETRY
                            </Button>
                        }
                    >
                        <Typography variant="h6">Error Loading Privacy Policy</Typography>
                        <Typography variant="body2">{error}</Typography>
                    </Alert>
                </Container>
            </Box>
        );
    }

    return (
        <div className="about-ksm-page">
            <Header />


            {/* Content Section */}
            <div >

                <Container style={{ marginTop: " 130px" }} maxWidth="md">
                    <Card
                        sx={{
                            borderRadius: 20,
                            boxShadow: '0 20px 60px rgba(0,0,0,0.1)',
                            overflow: 'hidden',
                            mt: { xs: -4, md: -8 },

                        }}

                    >

                        <Title level={2} className="content-title">
                            {content.title}
                        </Title>

                        {/* Main Content */}
                        <Box sx={{ p: { xs: 3, md: 6 } }}>


                            <Box
                                sx={{
                                    // Base styles for all content
                                    lineHeight: 1.5, // Increased line height for better readability
                                    fontSize: '14px',
                                    color: 'text.primary',

                                    // Headings with proper spacing
                                    '& h1, & h2, & h3, & h4, & h5, & h6': {
                                        color: 'primary.main',
                                        fontWeight: 'bold !important',
                                        lineHeight: 1.4,
                                        marginTop: '25px !important', // Space before heading
                                        marginBottom: '1px !important', // Space after heading
                                    },
                                    '& h1': {
                                        fontSize: '1.75rem',
                                        marginTop: '0 !important', // No top margin for first heading
                                    },
                                    '& h2': {
                                        fontSize: '1.5rem',
                                        paddingBottom: '8px',
                                        borderBottom: '2px solid',
                                        borderColor: 'primary.main'
                                    },
                                    '& h3': { fontSize: '1.25rem' },
                                    '& h4': { fontSize: '1.1rem' },

                                    // Paragraphs with proper spacing
                                    '& p': {
                                        marginBottom: '12px !important', // Space between paragraphs
                                        marginTop: '0 !important',
                                        textAlign: 'justify',
                                        lineHeight: 1.5, // Slightly tighter for paragraphs
                                    },

                                    // Empty paragraphs or line breaks
                                    '& p:empty': {
                                        marginBottom: '12px !important', // Smaller space for empty lines
                                        height: '12px', // Visual height for empty lines
                                    },

                                    // Bold and italic text
                                    '& strong, & b': {
                                        fontWeight: 'bold !important',
                                    },
                                    '& em, & i': {
                                        fontStyle: 'italic !important',
                                    },

                                    // Lists with proper spacing
                                    '& ul, & ol': {
                                        marginTop: '12px !important',
                                        marginBottom: '20px !important',
                                        paddingLeft: '32px',
                                        lineHeight: 1.7,
                                    },
                                    '& li': {
                                        marginBottom: '12px !important', // Space between list items
                                        lineHeight: 1.6,
                                    },
                                    '& li:last-child': {
                                        marginBottom: '0 !important',
                                    },

                                    // Links
                                    '& a': {
                                        color: 'primary.main',
                                        textDecoration: 'underline',
                                        '&:hover': {
                                            color: 'primary.dark'
                                        }
                                    },

                                    // Blockquotes
                                    '& blockquote': {
                                        borderLeft: '4px solid',
                                        borderColor: 'primary.main',
                                        backgroundColor: 'primary.50',
                                        padding: '20px',
                                        margin: '24px 0 !important',
                                        fontStyle: 'italic',
                                        borderRadius: '0 8px 8px 0',
                                        lineHeight: 1.6,
                                    },

                                    // Horizontal rules for section breaks
                                    '& hr': {
                                        margin: '32px 0 !important',
                                        border: 'none',
                                        borderTop: '1px solid',
                                        borderColor: 'divider',
                                    },

                                    // No content message
                                    '& .no-content-message': {
                                        textAlign: 'center',
                                        padding: '60px 20px',
                                        color: 'text.secondary',
                                        lineHeight: 1.6,
                                    },

                                    // Specific spacing for your content structure
                                    '& h2 + p': {
                                        marginTop: '4px !important', // Less space after heading
                                    },

                                    '& p + ul, & p + ol': {
                                        marginTop: '8px !important', // Less space before lists
                                    },

                                    '& ul + p, & ol + p': {
                                        marginTop: '4px !important', // More space after lists
                                    }
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: content.content ||
                                        `<div class="no-content-message">
                                         <p>No terms and conditions content available at the moment.</p>
                                         <p>Please check back later or contact support for more information.</p>
                                       </div>`
                                }}
                            />


                        </Box>
                    </Card>


                </Container>
            </div>
        </div>
    );
};

export default PrivacyPolicy;